import React from 'react';
import { Box, useMediaQuery, useTheme } from '@ublend-npm/aulaui-core';
import { useFlags } from 'launchdarkly-react-client-sdk';
import MessageListAndToolsContainer from './MessageListAndTools/MessageListAndToolsContainer';

// Conversation view: fetches by params.id and displays messages (no modals)
const ConversationsContainer = ({ route }: any) => {
  const { palette, breakpoints } = useTheme();
  const isDesktop = useMediaQuery(breakpoints.up('md'));
  const ConverstaionMenu = route?.conversationsMenu;
  const { webAppFtResponsiveMessages202506 } = useFlags();
  return (
    webAppFtResponsiveMessages202506 && (
      <Box
        width="100%"
        height={isDesktop ? 'calc(100vh - 65px)' : 'calc(100vh - 61px)'}
        display="flex"
        bgcolor={palette.background.default}
      >
        <Box>{isDesktop && <ConverstaionMenu />}</Box>
        <Box
          sx={{
            width: '100%',
            p: isDesktop ? '24px' : '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            id="Sudo-vodo"
            width={{ xs: '100%', sm: '100%', md: '100%', lg: '80%' }}
            sx={{
              margin: 'auto',
              display: 'flex',
              height: '100vh',
              flexDirection: 'column',
            }}
          >
            <Box
              tabIndex={0}
              bgcolor={palette.background.paper}
              width="100%"
              borderRadius="8px"
              height="100%"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
              }}
            >
              <MessageListAndToolsContainer />
            </Box>
          </Box>
        </Box>
      </Box>
    )
  );
};

export default ConversationsContainer;
